// components
import CommonForm from "../Common/CommonForm";
import BaseApi from "../../utils/BaseApi";
import CommonActionModal from "../Common/CommonActionModal";

// icons
import EditIcon from '@mui/icons-material/Edit';
import TableViewIcon from "@mui/icons-material/TableView";
import {deleteArrayItemByKeyValue, splitToList} from "../../utils/misc";


class ChecklistConvertionRuleUpdate extends CommonActionModal {
    async componentDidMount() {
        this.setState({
            buttonIcon: EditIcon,
            ready: true,
        })
    }

    async beforeModalOpen(){
        let formFields = await this.retrieveFields()
        let object = this.props.componentObj
        object.questions = object.questions.map((e) => (e.id))
        return {
            modalLabel: 'Редактирование параметров конвертации',
            modalIcon: TableViewIcon,
            mainComponent: CommonForm,
            mainComponentProps: {
                object: object,
                fields: formFields,
                processForm: this.processForm.bind(this),
            },
        }
    }

    async retrieveFields(){
        const url = `checklist_convertion_rule/update_form/`;
        const api = new BaseApi();
        let response = await api.get(url, {});
        let formFields = response.data
        formFields = deleteArrayItemByKeyValue(
            formFields,
            'name',
            'checklist_type'
        );
        return formFields
    }

    async processForm(form) {
        let formDataObj = Object.fromEntries(
            form.state.formData.entries()
        );
        if ('questions' in formDataObj) {
            formDataObj.questions = splitToList(formDataObj.questions, ',')
        }
        const url = `checklist_convertion_rule/${this.props.componentObj.id}/`;
        const api = new BaseApi();
        let response = await api.patch(
            url,
            formDataObj
        );
        if (response.status === 200) {
            if (typeof this.props.callBack == 'function') {
                await this.props.callBack();
            }
            this.setModalOpenFalse();
        }
        return response
    }
}

export default ChecklistConvertionRuleUpdate
